// extracted by css-extract-rspack-plugin
export default {"root":"_11Ys_MdC_lFdTtv5alHF89"};